module.exports = __webpack_public_path__ + "img/9788989708254.cf88cce3.jpg";